import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import {
  AppLogger,
  Button,
  FilterType,
  ICardGroupItem,
  ICardItem,
  IFilterItem,
  RadioButton,
  TranformService,
} from 'app-core';
import {
  MajorCategories,
  IBodyScanDoctors,
  IDoctors,
  IHospital,
} from '@alpha/types';
import { BookmarkService, UIUtilService } from 'app-service';

import ButtonType = Data.Core.ButtonType;
import CardType = Data.Core.CardType;
import IconType = Data.Core.IconType;
import ShimmerType = Data.Core.ShimmerType;

@Component({
  selector: 'app-bookmarks',
  templateUrl: './bookmarks.component.html',
  styleUrls: ['./bookmarks.component.scss'],
})
export class BookmarksComponent implements OnInit, OnDestroy {
  public showFiltersButton: Button = new Button({
    label: 'Filters',
    type: ButtonType.flatButton,
    icon: IconType.filterIcon,
    action: () => this._showFilters(),
  });
  public filterItems: Array<IFilterItem> = [];
  public cards: Array<ICardGroupItem> = [];
  public noBookmarks: boolean = true;
  public radioFilter: FilterType = 'RadioButton';
  private listObj: Array<ICardItem> = [];
  public loading: boolean = false;
  public shimmerTypeLGCard: ShimmerType = ShimmerType.LGCard;
  private selectedCategoryFilter: MajorCategories = MajorCategories.Doctor;
  public categoryFilterItems: Array<RadioButton> = [
    {
      label: `Doctors`,
      value: MajorCategories.Doctor,
      checked:
        Number(this._activatedRoute.snapshot.queryParamMap.get('bcf')) ===
        Number(MajorCategories.Doctor)
          ? true
          : false,
    },
    {
      label: `Body Scan`,
      value: MajorCategories.BodyScan,
      checked:
        Number(this._activatedRoute.snapshot.queryParamMap.get('bcf')) ===
        Number(MajorCategories.BodyScan)
          ? true
          : false,
    },
  ];
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  public constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _bookmarkService: BookmarkService,
    private readonly _tranformService: TranformService,
    private readonly _router: Router,
    public readonly _uiUtilService: UIUtilService,
  ) {}

  ngOnInit() {
    this._addFilters();

    this._uiUtilService.isNavbarOpened.next(false);

    // Extract existing query params
    this._activatedRoute.queryParams.subscribe((params) => {
      if (
        !Number(params['bcf']) &&
        Number(params['bcf']) !== MajorCategories.Doctor
      ) {
        this._router.navigate(
          [], // Passing an empty array keeps you on the current route path
          {
            relativeTo: this._activatedRoute,
            queryParams: { bcf: this.selectedCategoryFilter }, // Your new parameters
            queryParamsHandling: 'merge', // 'merge' keeps existing params, use '' to overwrite
          },
        );
      } else {
        this._getBookmarksByCategory(Number(params['bcf']));
      }
    });
  }

  private _getBookmarksByCategory(category: MajorCategories): void {
    this.loading = true;
    this._bookmarkService
      .findBookmarksByCategory(category)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (
          list:
            | Array<Partial<IDoctors>>
            | Array<Partial<IBodyScanDoctors>>
            | Array<Partial<IHospital>>,
        ) => {
          if (list!.length > 0) {
            this.noBookmarks = false;
            this._updateBindings(list);
          } else {
            this.noBookmarks = true;
          }
        },
        (error) => {
          AppLogger.Error(error);
        },
        () => {
          this.loading = false;
        },
      );
  }

  private _updateBindings(
    list:
      | Array<Partial<IDoctors>>
      | Array<Partial<IBodyScanDoctors>>
      | Array<Partial<IHospital>>
      | undefined,
  ): void {
    this.cards = [];
    this.listObj = this._tranformService.updateLGCardObject(list);
    this.listObj.forEach((item) => {
      item.onArrowClick = (item: any) => this.onArrowClick(item);
      item.showBookmark = true;
    });
    this.cards.push({
      items: this.listObj,
      type: CardType.lg,
    });

    this._cdRef.markForCheck();
  }

  private onArrowClick(item: any): void {
    const route = `/appointments/${item._id}`;
    this._router
      .navigate([route], {
        queryParams: { x: 1 },
        queryParamsHandling: ''
      })
      .catch((err: string | Error) => AppLogger.Error(err));
  }

  private _showFilters(): void {
    this._uiUtilService.isNavbarOpened.next(true);
  }

  private _addFilters(): void {
    this.filterItems.push({
      title: 'Filter By Category',
      filters: {
        list: () => [...this.categoryFilterItems],
        type: this.radioFilter,
      },
      onItemSelected: (id: any) => {
        this.selectedCategoryFilter = id.value;
        this._router.navigate(
          [], // Passing an empty array keeps you on the current route path
          {
            relativeTo: this._activatedRoute,
            queryParams: { bcf: this.selectedCategoryFilter }, // Your new parameters
            queryParamsHandling: 'merge', // 'merge' keeps existing params, use '' to overwrite
          },
        );
      },
      selectedItem:
        Number(this._activatedRoute.snapshot.queryParamMap.get('bcf')) ===
        Number(MajorCategories.BodyScan)
          ? this.categoryFilterItems[1].value
          : this.categoryFilterItems[0].value,
      expanded: true,
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
